import React, { useEffect, } from 'react';
import { keyBy, isEmpty } from 'lodash';
import { toast } from 'react-toastify';
import qs from 'qs';

import env from '../../env';
import firebase from '../../firebase';
import { isMobile } from '../../util';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import AdminHeaderNav from '../AdminHeaderNav';
import AdminSideNav from '../AdminSideNav';
import AdminBottomNav from '../AdminBottomNav';

const db = firebase.firestore();
const shippingRequestsRef = db.collectionGroup('shippingRequests');

const navItems = [
  {
    path: '/admin/useCounts',
    label: _ => '利用状況',
  },
  {
    path: '/admin/printers',
    label: _ => 'プリンター管理',
  },
  {
    path: '/admin/tenants',
    label: _ => 'テナント管理',
  },
  {
    path: '/admin/users',
    label: _ => 'ユーザー管理',
  },
  {
    path: '/admin/locations',
    label: _ => 'ロケーション管理',
  },
  {
    path: '/admin/products',
    label: _ => '商品管理',
  },
  {
    path: '/admin/noSizeProducts',
    label: _ => 'サイズ未設定商品',
  },
  {
    path: '/admin/noFnskuLabelInventories',
    label: _ => 'FNSKUラベルなし在庫',
  },
  {
    path: '/admin/receivingRequests',
    search: '?' + qs.stringify({ tenantIds: [`${env('TENANT_PREFIX')}1`] }),
    label: _ => '入荷依頼管理',
  },
  {
    path: '/admin/receivements',
    label: _ => '入庫処理',
    auth: _ => _.isStaff,
  },
  {
    path: '/admin/unknownInventories',
    label: _ => '不明在庫',
    auth: _ => _.isStaff,
  },
  {
    path: '/admin/shippingRequests',
    label: ({ shippingRequestsToDiscard, shippingRequestsToCancel }) => {
      return (
        <span>
          <span>出荷依頼管理</span>
          {!isEmpty(shippingRequestsToDiscard) && <span className="ml-1 badge badge-warning">{shippingRequestsToDiscard.length}</span>}
          {!isEmpty(shippingRequestsToCancel) && <span className="ml-1 badge badge-danger">{shippingRequestsToCancel.length}</span>}
        </span>
      );
    },
  },
  {
    path: '/admin/shippings',
    label: _ => '出荷処理',
    auth: _ => _.isStaff,
  },
  {
    path: '/admin/combiningRequests',
    label: _ => '加工依頼管理',
  },
  {
    path: '/admin/combinings',
    label: _ => '加工処理',
    auth: _ => _.isStaff,
  },
  {
    path: '/admin/pickingItems',
    label: _ => 'ピッキングアイテム管理',
  },
  {
    path: '/admin/pickingStats',
    label: _ => 'ピッキング統計',
  },
  {
    path: '/admin/exports',
    label: _ => 'データ出力',
  },
  {
    path: '/admin/settings',
    label: _ => '設定',
  },
].map(_ => ({ ..._, auth: u => _.auth?.(u) || u.admin, }));
const navItemsByPath = keyBy(navItems, 'path');

export default function AdminPageHOC(WrappedComponent) {
  const { forPrint = false } = WrappedComponent;

  return function AdminPage (props) {
    const { location, history, user } = props;
    const shippingRequestsToDiscard = useCollectionSubscription(shippingRequestsRef.where('status', '==', 'waitingToDiscard'));
    const shippingRequestsToCancel = useCollectionSubscription(shippingRequestsRef.where('status', '==', 'cancelling'));
    const isAuthorized = user.admin || navItemsByPath[location.pathname]?.auth(user);

    useEffect(() => {
      if(!isAuthorized) {
        toast.error('Unauthorized');
        history.replace('/');
      }
    }, [isAuthorized]);

    return isAuthorized ? (
      forPrint ? (
        <div className="page d-flex flex-column" style={{ minHeight: '100vh' }}>
          <div className="flex-fill">
            <WrappedComponent {...{ ...props, }} />
          </div>
        </div>
      ) : (
        <div className="page d-flex flex-column" style={{ minHeight: '100vh' }}>
          <AdminHeaderNav {...{ ...props, }} />
          <div className="d-flex flex-fill">
            {
              !isMobile() && (
                <AdminSideNav {...{ ...props, navItems, shippingRequestsToDiscard, shippingRequestsToCancel, }} style={{ width: 250, minWidth: 250, }} />
              )
            }
            <div className="flex-fill">
              <WrappedComponent {...{ ...props, shippingRequestsToDiscard, shippingRequestsToCancel, }} />
            </div>
          </div>
          {
            isMobile() && (
              <AdminBottomNav {...props} />
            )
          }
        </div>
      )
    ) : null;
  };
};
